import { Spine } from '@esotericsoftware/spine-pixi-v8';
import { GameConstants } from '../gameClientEvents/GameConstants';
// import { Texture } from "pixi.js";


// Define the mapping configuration
const symbolConfig: Record<number, { staticSymName: string; skeleton: string; atlas: string }> = {
    0: {
        staticSymName: "wildStatic",
        skeleton: "wildSkel",
        atlas: "wildAtlas"
    },
    1: {
        staticSymName: "lv1Static",
        skeleton: "lv1Skel",
        atlas: "lv1Atlas"
    },
    2: {
        staticSymName: "lv2Static",
        skeleton: "lv2Skel",
        atlas: "lv2Atlas"
    },
    3: {
        staticSymName: "lv3Static",
        skeleton: "lv3Skel",
        atlas: "lv3Atlas"
    },
    4: {
        staticSymName: "lv4Static",
        skeleton: "lv4Skel",
        atlas: "lv4Atlas"
    },
    5: {
        staticSymName: "lv5Static",
        skeleton: "lv5Skel",
        atlas: "lv5Atlas"
    },
    10: {
        staticSymName: "hv5Static",
        skeleton: "hv5Skel",
        atlas: "hv5Atlas"
    },
    6: {
        staticSymName: "hv1Static",
        skeleton: "hv1Skel",
        atlas: "hv1Atlas"
    },
    7: {
        staticSymName: "hv2Static",
        skeleton: "hv2Skel",
        atlas: "hv2Atlas"
    },
    8: {
        staticSymName: "hv3Static",
        skeleton: "hv3Skel",
        atlas: "hv3Atlas"
    },
    9: {
        staticSymName: "hv4Static",
        skeleton: "hv4Skel",
        atlas: "hv4Atlas"
    },
    12: {
        staticSymName: "scatterStatic",
        skeleton: "scatterSkel",
        atlas: "scatterAtlas"
    },
    // 13: {
    //     staticSymName: "windmillStatic",
    //     skeleton: "windmillSkel",
    //     atlas: "windmillAtlas"
    // },
    // 14: {
    //     staticSymName: "shutterStatic",
    //     skeleton: "shutterSkel",
    //     atlas: "shutterAtlas"
    // },

    // Add more mappings as needed
};

export function isOversizeSymbol(symbolIndex: number): boolean {

    // let isSymbolOversize = false;
    // if(symbolIndex == 0)// || symbolIndex == 9)
    // {
    //     isSymbolOversize=true;
    // }
    // return isSymbolOversize;


    let isSymbolOversize = false;
    if (symbolIndex == 0)// || symbolIndex == 9)
    {
        isSymbolOversize = false;
    }
    return isSymbolOversize;

}

export function isLandingAnimationExist(symbolIndex: number): boolean {

    // let isLandingExist = false;
    // if(symbolIndex == 0 || symbolIndex == 9)
    // {
    //     isLandingExist=true;
    // }
    // return isLandingExist;

    let isLandingExist = true;
    if (symbolIndex == 0 || symbolIndex == 9) {
        isLandingExist = true;
    }
    return isLandingExist;
}


export function isIdleExist(symbolIndex: number): boolean {
    let isIdleExist = false;
    if (symbolIndex === GameConstants.WINDMILL_SYMBOL_ID) {
        isIdleExist = true;
    }
    return isIdleExist;
}


// export function getSymbol(symbolIndex: number): Texture  {

//     let staticSymName: string = '';

//     const symbol = symbolConfig[symbolIndex];

//     if (symbol) {
//             staticSymName= symbol.staticSymName;
//     } 

//     const staticSymbol: Texture = Texture.from(staticSymName);
//     return staticSymbol;

// }

// import { Spine } from '@esotericsoftware/spine-pixi-v8';

export function getSpineSymbol(symbolIndex: number): Spine {
    // console.log("symbolIndex in getSpineSymbol ", symbolIndex);

    const symbol = symbolConfig[symbolIndex];

    let skeletonVal: string = '';
    let atlasVal: string = '';

    if (symbol) {

        skeletonVal = symbol.skeleton;
        atlasVal = symbol.atlas;

    }

    const spineSymbol: Spine = Spine.from({
        skeleton: skeletonVal,
        atlas: atlasVal,
    });

    if (symbolIndex === GameConstants.WINDMILL_SYMBOL_ID) {
        spineSymbol.state.setAnimation(0, "idle", false);
        spineSymbol.state.update(0);
    }

    return spineSymbol;
}






